import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { fleetSuppliesPrefix, fleetSuppliesGasStation } = useReportFiltersFetch({ fetchFleetSuppliesPrefix: true, fetchFleetSuppliesGasStation: true });

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <SelectComponent
                        label="Prefixo"
                        isMulti={true}
                        wrapValues={true}
                        options={fleetSuppliesPrefix}
                        value={filters.prefix}
                        onChange={(value) => setFilters(prev => ({...prev, prefix: value}))}
                        id="prefix"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label="Tipo de combustível"
                        isMulti={true}
                        wrapValues={true}
                        options={[
                            {label: "Arla 32 (litros)", value: 'arla32'},
                            {label: "Diesel (litros)", value: 'diesel'},
                            {label: "Elétrico (kWh)", value: 'electric'},
                            {label: "Etanol (litros)", value: 'ethanol'},
                            {label: "Gasolina (litros)", value: 'gasoline'},
                            {label: "GNV (m3)", value: 'gnv'},
                        ]}
                        value={filters.fuel_type}
                        onChange={(value) => setFilters(prev => ({...prev, fuel_type: value}))}
                        id="fuel_type"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label="Posto de combustível"
                        isMulti={true}
                        wrapValue={true}
                        options={fleetSuppliesGasStation}
                        value={filters.gas_station}
                        onChange={(value) => setFilters(prev => ({ ...prev, gas_station: value }))}
                        id="gas_station"
                        classNameWrapper={"w-full"}
                    />

                </form>
            </div>
        </>
    );
};

export default Filters;